import { Component, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
    selector: "app-lms",
    templateUrl: "./lms.component.html",
    styleUrls: ["./lms.component.scss"],
})
export class LmsComponent implements OnInit {

    constructor(private meta: Meta, private seoService: SeoServiceService) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.meta.addTag({
            name: "Description",
            content: "LMS Platform - Complete Learning Management Ecosystem for Schools and Coaching Centers.",
        });
    }

    features = [
        { icon: 'fact_check', title: 'Smart Attendance', description: 'Automated attendance tracking' },
        { icon: 'assignment', title: 'Homework & Assignments', description: 'Easy submission and grading' },
        { icon: 'live_tv', title: 'Live/Recorded Classes', description: 'Interactive virtual learning' },
        { icon: 'quiz', title: 'Exam & Test Engine', description: 'Comprehensive assessment tools' },
        { icon: 'dashboard', title: 'Teacher Dashboard', description: 'Centralized control for educators' },
        { icon: 'family_restroom', title: 'Parent App', description: 'Real-time updates for parents' },
        { icon: 'receipt_long', title: 'Fee & Report Cards', description: 'Streamlined administrative tasks' },
        { icon: 'analytics', title: 'AI-Based Analytics', description: 'Data-driven insights' },
        { icon: 'edit', title: 'Customize Your LMS Dashboard', description: 'Tailored interface for your needs' },
    ];

    dashboardScreenshots = [
        { title: 'Teacher Panel', image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/evKkaeoYa25OmoVw8l7o2qRRpN1cRNLuSf9FA26H.jpg' }, // Placeholder
        { title: 'Student Panel', image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/JSUtfdiTrqtPmGO94DC00fmJUZlOwGuJe6Qj9q7q.jpg' }, // Placeholder
        // { title: 'Parent App', image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/v9N10SAhFwJwzFa0xGbklVM7BEFvyvGHKTJu0kIP.jpg' }, // Placeholder
        { title: 'Reports Dashboard', image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/Ivxn6WpLRAoyMP9ap5bVjDxiZSgT2mMJH986hG2N.jpg' } // Placeholder
    ];

    pricingPlans = [
        {
            name: 'School Plan',
            features: ['Attendance', 'Homework', 'Report Cards', 'Parent App'],
            price: 'Contact for pricing'
        },
        {
            name: 'Coaching Plan',
            features: ['Live Classes', 'Test Engine', 'Student Analytics', 'Fee Management'],
            price: 'Contact for pricing'
        },
        {
            name: 'Enterprise Plan',
            features: ['Custom Branding', 'API Access', 'Dedicated Support', 'Multi-Branch Management'],
            price: 'Contact for pricing'
        }
    ];
}
